import axiosRetry from "axios-retry";

export const shouldRetryForNode404 = (error) => {
  return (
    axiosRetry.isNetworkError(error) ||
    axiosRetry.isRetryableError(error) ||
    error.code === "ECONNABORTED" ||
    (error.response && error.response.status === 429) ||
    (error.response && error.response.status === 404)
  );
};
